import { render, staticRenderFns } from "./TiJianChaXun.vue?vue&type=template&id=4bc0bd70&scoped=true"
import script from "./TiJianChaXun.vue?vue&type=script&lang=js"
export * from "./TiJianChaXun.vue?vue&type=script&lang=js"
import style0 from "./TiJianChaXun.vue?vue&type=style&index=0&id=4bc0bd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0bd70",
  null
  
)

export default component.exports